import ApiService from "@/common/api.service";

const PATH = "stock/transfers";

export const GET_STOCK_TRANSFERS = "getStockTransfers";
export const GET_STOCK_TRANSFER = "getStockTransfer";
export const CREATE_STOCK_TRANSFER = "createStockTransfer";
export const UPDATE_STOCK_TRANSFER = "updateStockTransfer";
export const FINALIZE_STOCK_TRANSFER = "finalizeStockTransfer";
export const CANCEL_STOCK_TRANSFER = "cancelStockTransfer";
export const DISCARD_STOCK_TRANSFER = "discardStockTransfer";
export const REVERSE_STOCK_TRANSFER = "reverseStockTransfer";
export const GET_STOCK_TRANSFER_SUGGEST_LOTS = "getStockTransferSuggestLots";
export const GET_STOCK_TRANSFER_SUGGEST_DRAFT_LOTS = "getStockTransferSuggestDraftLots";
export const UPLOAD_STOCK_TRANSFER_FILES = "uploadStockTransferFiles";
export const DELETE_STOCK_TRANSFER_FILE = "deleteStockTransferFile";
export const DOWNLOAD_STOCK_TRANSFER_FILE = "downloadStockTransferFile";

const actions = {
  [GET_STOCK_TRANSFERS](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.query(PATH, {
        ...(params || {}),
        ...context.rootGetters.stockContextFilterParams,
      })
        .then(({ data }) => resolve(data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.get(PATH, id)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CREATE_STOCK_TRANSFER](context, params) {
    return new Promise((resolve, reject) => {
      ApiService.post(PATH, params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPDATE_STOCK_TRANSFER](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.update(PATH, payload.id, payload.params)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [FINALIZE_STOCK_TRANSFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/finalize`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [CANCEL_STOCK_TRANSFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/cancel`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DISCARD_STOCK_TRANSFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/discard`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [REVERSE_STOCK_TRANSFER](context, id) {
    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${id}/reverse`)
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER_SUGGEST_LOTS](context, payload) {
    const transferId = payload.transferId || payload.id;
    const params = payload.params || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/${transferId}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [GET_STOCK_TRANSFER_SUGGEST_DRAFT_LOTS](context, payload) {
    const params = (payload && payload.params) || {};

    return new Promise((resolve, reject) => {
      ApiService.query(`${PATH}/suggest-lots`, params)
        .then(({ data }) => resolve(data.data || data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [UPLOAD_STOCK_TRANSFER_FILES](context, payload) {
    const formData = new FormData();
    (payload.files || []).forEach((file) => formData.append("files[]", file));

    return new Promise((resolve, reject) => {
      ApiService.post(`${PATH}/${payload.id}/files`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
        .then(({ data }) => resolve(data.data))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DELETE_STOCK_TRANSFER_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.delete(`${PATH}/${payload.id}/files/${payload.fileId}`)
        .then(() => resolve(true))
        .catch(({ response }) => reject(response?.data));
    });
  },

  [DOWNLOAD_STOCK_TRANSFER_FILE](context, payload) {
    return new Promise((resolve, reject) => {
      ApiService.downloadFile(
        `${PATH}/${payload.id}/files/${payload.fileId}/download`,
        payload.originalName || payload.name || "download"
      )
        .then(() => resolve(true))
        .catch((error) => reject(error?.response?.data || error));
    });
  },
};

export default {
  state: {},
  getters: {},
  actions,
  mutations: {},
};
